<script lang="ts">
  import { createPDF } from '$lib/utils/helpers';

  import Wrapper from '$components/common/Simulator/Wrapper.svelte';
  import Description from '$components/common/Simulator/Description.svelte';
  import Form from '$components/common/Simulator/Form.svelte';
  import Actions from '$components/common/Simulator/Actions.svelte';
  import Action from '$components/common/Simulator/Action.svelte';
  import NextSteps from '$components/common/Simulator/NextSteps.svelte';
  import GlobalSynthesis from '$components/pages/simulateur-acquisition/GlobalSynthesis.svelte';

  import acquisitionSimulatorManager from '$lib/managers/acquisition-simulator.svelte';

  let { currentStep, steps, previousStep, goToPreviousStep } = $derived(
    acquisitionSimulatorManager,
  );

  let printableRef = $state<HTMLElement | undefined>();

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();

    createPDF(printableRef as HTMLElement, 'recapitulatif-simulation.pdf');
  };
</script>

<Wrapper>
  <Description
    title="Simulateur d'acquisition"
    stepTitle={`${currentStep.step}. ${currentStep.title}`}
    currentStep={currentStep.step}
    stepCount={steps.length}>
    <p>
      Voici le résumé de la simulation de votre projet d'acquisition en bail
      réel solidaire (BRS). Les montants et calculs présentés ci-dessous sont
      des estimations basées sur les informations que vous avez renseignées et
      ne constituent pas une offre ferme de financement. Cette simulation est
      fournie à titre informatif uniquement. Les conditions réelles de
      financement peuvent différer selon votre situation personnelle et les
      critères d'octroi des organismes prêteurs.
    </p>
  </Description>
  <Form onSubmit={handleSubmit}>
    <div class="fieldset-container">
      <fieldset class="fr-fieldset">
        <div
          class="fr-fieldset__element"
          bind:this={printableRef}>
          <GlobalSynthesis />
        </div>
      </fieldset>
    </div>

    <Actions>
      <Action
        direction="previous"
        label={previousStep?.title as string}
        onClick={goToPreviousStep} />
      <Action
        label="Télécharger le récapitulatif"
        type="submit" />
    </Actions>

    <NextSteps isEligible />
  </Form>
</Wrapper>
